import React from "react";
import PageTitle from "../PageTitle";
import { doRequest, dovocalRequest } from "../../helper";
import $, { valHooks } from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import axios from "axios";
import { saveAs } from "file-saver";
import moment from "moment";

const BASC_URL = "https://d1zez9d7l5hgkm.cloudfront.net";
// var BASC_URL = "http://localhost:8000";
export default class IndianDiasporaModeration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      response: null,
      count: 0,
      status: "",
      tab: "Enabled",
      country: "",
      year: "",
      category: "",
      points: 1,
      // lastEvaluatedKey: "",
      loadMoreDisplay: false,
      selectedPhotos: [],
      isChecked: false,
      fromDate: "",
      toDate: "",
      limit: 50,
      page: 1,
      selectedButton: null,
      popupImageUrl: "",
      postDetail: {},
      selectedPostActivity: "",
    };
    this.update = this.update.bind(this);
    this.rejectupdate = this.rejectupdate.bind(this);
    this.getPromoted = this.getPromoted.bind(this);
    this.getGallerydata = this.getGallerydata.bind(this);
    this.selectToggle = this.selectToggle.bind(this);
  }

  componentDidMount() {
    var status = this.props.match.params.status;
    if (!status) {
      status = "1";
    } else if (status == "enabled") {
      status = 1;
    } else if (status == "disabled") {
      status = 0;
    }
    if (status == 0) {
      this.setState({
        tab: "disable",
      });
      this.getGallerydata("loadmore", this.state.page, status, "");
    } else if (status == "promoted") {
      this.setState({
        tab: "promoted",
      });
      this.getPromoted("", 1, 1, "promoted", 1);
    } else {
      this.setState({
        tab: "enable",
      });
      this.getGallerydata("loadmore", this.state.page, status, "");
    }
  }

  getGallerydata(loadmore, pageno, status, point) {
    var ref = this;
    ref.setState({
      status: status,
    });

    if (!loadmore) {
      ref.setState({ items: [], page: 1 });
    }

    if (new Date(this.state.fromDate) > new Date(this.state.toDate)) {
      alert("From date cannot be greater than to date.");
      return;
    }
    $("#loader").css({ display: "block" });
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `${BASC_URL}/v1/indiandiaspora/getpostlistformoderation?limit=${
        // `https://d1zez9d7l5hgkm.cloudfront.net/v1/indiandiaspora/getpostlist?limit=${
        this.state.limit
      }&page=${pageno ? pageno : this.state.page}&status=${status}&country=${
        this.state.country
      }&year=${this.state.year}&category=${this.state.category}&from=${
        this.state.fromDate
      }&to=${this.state.toDate}&v=${Math.random()}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        if (result && (result.resultFlag === 1 || result.resultFlag === "1")) {
          if (status == 0) {
            if (loadmore) {
              ref.setState(
                {
                  items: [...ref.state.items, ...result.response.postList],
                  count: result.response.count,
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            } else {
              ref.setState(
                {
                  items: [...result.response.postList],
                  count: result.response.count,
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            }
          } else {
            ref.setState(
              {
                items: [...ref.state.items, ...result.response.postList],
                count: result.response.count,
              },
              () => {
                $("#loader").css({ display: "none" });
              }
            );
          }
          if (
            result.response.postList.length.toString() >=
            this.state.limit - 1
          ) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
        }
      })
      .catch((error) => console.log("error", error));
  }

  getPromoted(loadmore, pageno, status, point, promot) {
    $("#loader").css({ display: "block" });
    var ref = this;
    ref.setState({
      status: status,
    });
    if (point == "promoted") {
      ref.setState({
        points: 2,
      });
    }
    if (!loadmore) {
      ref.setState({ items: [], page: 1 });
    }
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `${BASC_URL}/v1/indiandiaspora/getpostlistformoderation?&limit=${
        this.state.limit
      }&page=${pageno ? pageno : this.state.page}&status=1&vip_post=${
        promot ? promot : ""
      }&v=${Math.random()}&country=${this.state.country}&year=${
        this.state.year
      }&category=${this.state.category}&from=${this.state.fromDate}&to=${
        this.state.toDate
      }&v=${Math.random()}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result && (result.resultFlag === 1 || result.resultFlag === "1")) {
          if (status == "0") {
            if (loadmore) {
              ref.setState(
                {
                  items: [...ref.state.items, ...result.response.postList],
                  count: result.response.count,
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            } else {
              ref.setState(
                {
                  items: [...result.response.postList],
                  count: result.response.count,
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            }
          } else {
            ref.setState(
              {
                items: [...ref.state.items, ...result.response.postList],
                count: result.response.count,
              },
              () => {
                $("#loader").css({ display: "none" });
              }
            );
          }
          if (result.response.postList.length.toString() >= this.state.limit) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
        }
      })
      .catch((error) => console.log("error", error));
  }

  update(id, status) {
    let confirm = window.confirm(
      status === "1"
        ? "Are you sure you want to promote this post ?"
        : "Are you sure you want to remove from promote this post ?"
    );
    // return;
    if (confirm) {
      var ref = this;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        post_id: id.toString(),
        vip_post: status,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(BASC_URL + "/v1/indiandiaspora/updatepost", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result && result["resultFlag"] == 1) {
            window.location.reload();
            // $("#post_" + id).hide();
          }
        })
        .catch((error) => console.log("error", error));
    }
    // $("#loader").css({ display: "block" });
  }

  rejectupdate(id, status) {
    let confirm = window.confirm(
      status == "1"
        ? "Are you sure you want to enable this post ?"
        : "Are you sure you want to disable this post ?"
    );
    if (confirm) {
      var ref = this;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        post_id: id.toString(),
        status: status,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(BASC_URL + "/v1/indiandiaspora/updatepost", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (
            result &&
            (result.resultFlag === 1 || result.resultFlag === "1")
          ) {
            console.log("hello", result);
            $("#post_" + id).hide();
          }
        })
        .catch((error) => console.log("error", error));
    }
    // $("#loader").css({ display: "block" });
  }

  loadMoreData = () => {
    this.setState({
      page: this.state.page + 1,
    });
    $("#loader").css({ display: "block" });
    this.getGallerydata("loadmore", this.state.page + 1, this.state.status);
    $("#loader").css({ display: "none" });
  };

  selectToggle() {
    if ($(".allChecked").length > 0) {
      $(".multi_select").prop("checked", false);
      $(".multi_select").removeClass("allChecked");
    } else {
      $(".multi_select").prop("checked", true);
      $(".multi_select").addClass("allChecked");
    }
  }

  UnselectChekbox = () => {
    this.setState({ selectedPhotos: [] });
  };

  render() {
    var status = this.props.match.params.status;
    if (!status) {
      status = 1;
    }
    var bread = "Indian Diaspora Stories / Moderation (Enabled Posts)";
    var pagelink = "/indiandiaspora/moderation";
    if (status == "disabled") {
      bread = "Indian Diaspora Stories/ Moderation (Disabled Posts)";
      pagelink += "/disabled";
    } else if (status == "promoted") {
      bread = "Indian Diaspora Stories/ Moderation (Featured Posts)";
      pagelink += "/promoted";
    } else {
      bread = "Indian Diaspora Stories/ Moderation (Enabled Posts)";
      pagelink += "/enabled";
    }
    var items = this.state.items;
    var links = [
      {
        link: "/meihumodiparivar/moderation/disabled",
        name: "View Disabled Posts",
      },
      {
        link: "/meihumodiparivar/moderation/enabled",
        name: "View Active Posts",
      },
    ];
    var pagination = [];
    if (this.state.response && countdata) {
      var countdata = this.state.response.countdata;
      var pages = Math.ceil(countdata.Count / this.state.limit);

      for (var i = 1; i <= pages; i++) {
        pagination.push(
          <span key={i}>
            <NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">
              {i}
            </NavLink>
            &nbsp;
          </span>
        );
      }
    }

    const years = [];
    for (let year = 1900; year <= 2025; year++) {
      years.push(year);
    }
    // setYearsArr(years)

    const { selectedPhotos } = this.state;
    const { isChecked } = this.state;

    const countryNames = [
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Brazil",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Colombia",
      "Comoros",
      "Congo",
      "Costa Rica",
      "Côte d'Ivoire",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Ethiopia",
      "Fiji",
      "Finland",
      "France",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Greece",
      "Grenada",
      "Guatemala",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Honduras",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "North Korea",
      "South Korea",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Lithuania",
      "Luxembourg",
      "Macedonia",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Mauritania",
      "Mauritius",
      "Mexico",
      "Micronesia",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Qatar",
      "Romania",
      "Russia",
      "Rwanda",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Sint Maarten",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syria",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Vatican City",
      "Venezuela",
      "Vietnam",
      "Yemen",
      "Zambia",
      "Zimbabwe",
    ];

    const categories = [
      "Freedom Struggle Contributions",
      "Cultural Preservation",
      "Community Building",
      "Iconic Indians Abroad",
      "Generational Journeys",
      "Others",
    ];
    return (
      <div>
        <PageTitle
          title="Indian Diaspora Stories"
          bread={bread}
          //   links={links}
          counttype={
            this.state.tab == "disable"
              ? "Disabled"
              : this.state.tab == "promoted"
              ? "Featured"
              : "Enabled"
          }
          Count={this.state.count}
        />

        <div className="filterbg">
          <div className="filter_contert">
            <div style={{ display: "flex", padding: "10px", margin: "10px" }}>
              <div className="user_form_detail" style={{ marginRight: "20px" }}>
                <label>Country *</label>
                <select
                  // value={country}
                  value={this.state.country}
                  className="form-control"
                  onChange={(e) =>
                    this.setState(
                      { country: e.target.value, items: [] },
                      () => {
                        var status = this.props.match.params.status;
                        if (!status) {
                          status = 1;
                          this.getGallerydata(
                            "loadmore",
                            this.state.page,
                            status,
                            ""
                          );
                        } else if (status == "enabled") {
                          status = 1;
                          this.getGallerydata(
                            "loadmore",
                            this.state.page,
                            status,
                            ""
                          );
                        } else if (status == "disabled") {
                          status = 0;
                          this.getGallerydata(
                            "loadmore",
                            this.state.page,
                            status,
                            ""
                          );
                        } else if (status == "promoted") {
                          this.getPromoted("", 1, 1, "promoted", 1);
                        }
                      }
                    )
                  }
                >
                  <option value={""}>Select Country</option>
                  {countryNames.map((country) => {
                    return <option value={country}>{country}</option>;
                  })}
                </select>
              </div>
              <div className="user_form_detail" style={{ marginRight: "20px" }}>
                <label>Year *</label>
                <select
                  className="form-control"
                  value={this.state.year}
                  // onChange={(e) => setCountry(e.target.value)}
                  onChange={(e) =>
                    this.setState({ year: e.target.value, items: [] }, () => {
                      var status = this.props.match.params.status;
                      if (!status) {
                        status = 1;
                        this.getGallerydata(
                          "loadmore",
                          this.state.page,
                          status,
                          ""
                        );
                      } else if (status == "enabled") {
                        status = 1;
                        this.getGallerydata(
                          "loadmore",
                          this.state.page,
                          status,
                          ""
                        );
                      } else if (status == "disabled") {
                        status = 0;
                        this.getGallerydata(
                          "loadmore",
                          this.state.page,
                          status,
                          ""
                        );
                      } else if (status == "promoted") {
                        this.getPromoted("", 1, 1, "promoted", 1);
                      }
                    })
                  }
                >
                  <option value={""}>Select Year</option>
                  {years.map((year) => {
                    return <option value={year}>{year}</option>;
                  })}
                </select>
              </div>

              <div className="user_form_detail" style={{ marginRight: "20px" }}>
                <label>Category *</label>
                <select
                  className="form-control"
                  value={this.state.category}
                  // onChange={(e) => setCategory(e.target.value)}
                  onChange={(e) =>
                    this.setState(
                      { category: e.target.value, items: [] },
                      () => {
                        var status = this.props.match.params.status;
                        if (!status) {
                          status = 1;
                          this.getGallerydata(
                            "loadmore",
                            this.state.page,
                            status,
                            ""
                          );
                        } else if (status == "enabled") {
                          status = 1;
                          this.getGallerydata(
                            "loadmore",
                            this.state.page,
                            status,
                            ""
                          );
                        } else if (status == "disabled") {
                          status = 0;
                          this.getGallerydata(
                            "loadmore",
                            this.state.page,
                            status,
                            ""
                          );
                        } else if (status == "promoted") {
                          this.getPromoted("", 1, 1, "promoted", 1);
                        }
                      }
                    )
                  }
                >
                  <option value={""}>Select Category</option>
                  {categories.map((cat) => {
                    return <option value={cat}>{cat}</option>;
                  })}
                </select>
              </div>

              <div className="user_form_detail" style={{ marginRight: "20px" }}>
                {/* <label>Date *</label> */}
                <div style={{ display: "flex" }}>
                  <div>
                    <label>From</label>
                    <input
                      type="date"
                      className="form-control"
                      value={this.state.fromDate}
                      onChange={(e) =>
                        this.setState({ fromDate: e.target.value }, () => {
                          console.log(this.state.fromDate, "....");

                          if (this.state.toDate) {
                            this.setState({ items: [] }, () => {
                              var status = this.props.match.params.status;
                              if (!status) {
                                status = 1;
                                this.getGallerydata(
                                  "loadmore",
                                  this.state.page,
                                  status,
                                  ""
                                );
                              } else if (status == "enabled") {
                                status = 1;
                                this.getGallerydata(
                                  "loadmore",
                                  this.state.page,
                                  status,
                                  ""
                                );
                              } else if (status == "disabled") {
                                status = 0;
                                this.getGallerydata(
                                  "loadmore",
                                  this.state.page,
                                  status,
                                  ""
                                );
                              } else if (status == "promoted") {
                                this.getPromoted("", 1, 1, "promoted", 1);
                              }
                            });
                          }
                        })
                      }
                    />
                  </div>
                  <div style={{ marginLeft: "10px" }}>
                    <label>To </label>
                    <input
                      type="date"
                      className="form-control"
                      value={this.state.toDate}
                      onChange={(e) => {
                        this.setState(
                          {
                            toDate: e.target.value,
                          },
                          () => {
                            this.setState({ items: [] }, () => {
                              var status = this.props.match.params.status;
                              if (!status) {
                                status = 1;
                                this.getGallerydata(
                                  "loadmore",
                                  this.state.page,
                                  status,
                                  ""
                                );
                              } else if (status == "enabled") {
                                status = 1;
                                this.getGallerydata(
                                  "loadmore",
                                  this.state.page,
                                  status,
                                  ""
                                );
                              } else if (status == "disabled") {
                                status = 0;
                                this.getGallerydata(
                                  "loadmore",
                                  this.state.page,
                                  status,
                                  ""
                                );
                              } else if (status == "promoted") {
                                this.getPromoted("", 1, 1, "promoted", 1);
                              }
                            });
                          }
                        );
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="user_form_detail" style={{ padding: "25px" }}>
                <button
                  className="btn btn-primary btn-rounded"
                  onClick={() => {
                    this.setState(
                      {
                        country: "",
                        year: "",
                        category: "",
                        items: [],
                        fromDate: "",
                        toDate: "",
                      },
                      () => {
                        var status = this.props.match.params.status;
                        if (!status) {
                          status = 1;
                          this.getGallerydata(
                            "loadmore",
                            this.state.page,
                            status,
                            ""
                          );
                        } else if (status == "enabled") {
                          status = 1;
                          this.getGallerydata(
                            "loadmore",
                            this.state.page,
                            status,
                            ""
                          );
                        } else if (status == "disabled") {
                          status = 0;
                          this.getGallerydata(
                            "loadmore",
                            this.state.page,
                            status,
                            ""
                          );
                        } else if (status == "promoted") {
                          this.getPromoted("", 1, 1, "promoted", 1);
                        }
                      }
                    );
                  }}
                >
                  Reset
                </button>
              </div>
            </div>

            {/* <div className="user_form_detail">
                        <label>Category *</label>
                        <select>
                            <option value="">Select Category</option>
                            <option>
                                Swatch Bharat
                            </option>
                        </select>
                    </div> */}
          </div>
        </div>
        <div className="wrapper wrapper-content">
          {/* <br /> */}
          <h4>Disclaimer :</h4>
          <div className="form_maindiv">
            <div>
              <div className="form_checkdiv">
                <a
                  href="javascript:void(0);"
                  className="btn btn-primary btn-circle"
                  type="button"
                  title="promoted"
                >
                  <i className="fa fa-check"></i>
                </a>
                <p>Click on this icon to set as Featured.</p>
              </div>
              <div className="form_checkdiv">
                <a
                  href="javascript:void(0);"
                  className="btn btn-warning btn-circle"
                  type="button"
                  title="disable"
                >
                  <i className="fa fa-times"></i>
                </a>
                <p>Click on this icon to disable the image.</p>
              </div>
            </div>

            <div>
              <div className="form-inline form_right">
                <div>
                  <button
                    className={
                      this.state.points === 2
                        ? `btn btn-success btn-rounded`
                        : `btn btn-primary btn-rounded`
                    }
                    onClick={() => {
                      this.setState({ tab: "promoted" }, () => {
                        window.location.href =
                          "/indiandiaspora/moderation/promoted";
                        this.getPromoted("", 1, 1, "promoted", 1);
                      });
                    }}
                  >
                    Promoted
                  </button>
                  <button
                    className={
                      this.state.points === 1
                        ? `btn btn-success btn-rounded`
                        : `btn btn-primary btn-rounded`
                    }
                    onClick={() => {
                      this.setState({ tab: "enable" }, () => {
                        window.location.href =
                          "/indiandiaspora/moderation/enabled";
                        this.getGallerydata("", 1, 1, "enable", "");
                      });
                    }}
                  >
                    Enabled
                  </button>
                  <button
                    className={
                      this.state.points === 0
                        ? `btn btn-success btn-rounded`
                        : `btn btn-primary btn-rounded`
                    }
                    onClick={() => {
                      this.setState({ tab: "disable" }, () => {
                        window.location.href =
                          "/indiandiaspora/moderation/disabled";
                        this.getGallerydata("", 1, 0, "disable", "");
                      });
                    }}
                  >
                    Disabled
                  </button>
                </div>
              </div>
            </div>
          </div>

          <br />
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                {Array.isArray(items) && items.length == 0 && (
                  <p
                    id="nodatafound"
                    style={{
                      // display: "none",
                      textAlign: "center",
                      position: "relative",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "20px",
                      fontWeight: 800,
                    }}
                  >
                    No Data Found
                  </p>
                )}
                {Array.isArray(items) &&
                  items.length > 0 &&
                  items.map((value, index) => {
                    console.log("value", value.promoted);
                    return (
                      <div class="file-box" key={index} id={"post_" + value.id}>
                        <div class="file">
                          <a href="javascript:void(0);">
                            <span class="corner"></span>
                            <LazyLoad>
                              <div class="image" style={{ height: "auto" }}>
                                <div className="user_image_list">
                                  <ul>
                                    <li>
                                      {value.post_url &&
                                      value.post_url.length > 0 ? (
                                        value.post_url.map((val) => {
                                          return val.endsWith(".mp4") ? (
                                            <video
                                              controls
                                              style={{ width: "100%" }}
                                            >
                                              <source
                                                src={val}
                                                type="video/mp4"
                                              />
                                              Your browser does not support the
                                              video tag.
                                            </video>
                                          ) : (
                                            <a>
                                              <img src={val} alt="" />
                                            </a>
                                          );
                                        })
                                      ) : (
                                        <p>{value.description}</p>
                                      )}
                                    </li>
                                  </ul>
                                </div>
                                {/* <div className="image_caption vbactivity"> */}
                                <div className="image_caption vbactivity">
                                  {value.vip_post == 0 &&
                                    this.state.tab != "disable" && (
                                      <a
                                        href="javascript:void(0);"
                                        className="btn btn-primary btn-circle"
                                        onClick={() => {
                                          // if (this.state.tab == "enable") {
                                          this.update(value.id, 1);
                                          // } else if (
                                          //   this.state.tab == "promoted"
                                          // ) {
                                          //   this.update(value.id, 0);
                                          // }
                                        }}
                                        type="button"
                                        title="promoted"
                                      >
                                        <i className="fa fa-check"></i>
                                      </a>
                                    )}
                                  <a
                                    href="javascript:void(0);"
                                    className="btn btn-warning btn-circle"
                                    onClick={() => {
                                      if (this.state.tab == "enable") {
                                        this.rejectupdate(value.id, 0);
                                      } else if (this.state.tab == "promoted") {
                                        this.update(value.id, 0);
                                      } else if (this.state.tab == "disable") {
                                        this.rejectupdate(value.id, 1);
                                      }
                                    }}
                                    type="button"
                                    title={
                                      this.state.tab == "enable"
                                        ? "disable"
                                        : this.state.tab == "promoted"
                                        ? "remove from promoted"
                                        : this.state.tab == "disable"
                                        ? "remove from disable"
                                        : ""
                                    }
                                  >
                                    <i className="fa fa-times"></i>
                                  </a>
                                </div>
                              </div>
                            </LazyLoad>
                            <div class="file-name">
                              Name:{" "}
                              {value.user_name_display
                                ? value.user_name_display
                                : ""}
                              <br />
                              Country: {value.country ? value.country : ""}
                              <br />
                              Year: {value.year ? value.year : ""}
                              <br />
                              Category:{" "}
                              {value.category
                                ? value.category == "Others"
                                  ? value.manualcategory +
                                    " (" +
                                    value.category +
                                    ")"
                                  : value.category
                                : ""}
                              <br />
                              <small>
                                Added:{" "}
                                {value.created
                                  ? moment(value.created)
                                      .subtract(5, "hours")
                                      .subtract(30, "minutes")
                                      .format("DD-MM-YYYY")
                                  : ""}
                              </small>
                            </div>
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {this.state.loadMoreDisplay &&
              this.state.items.length > this.state.limit - 1 && (
                <button
                  style={{
                    position: "relative",
                    left: "50%",
                    transform: "translateX(-50%)",
                    padding: "10px 18px",
                  }}
                  type="button"
                  onClick={this.loadMoreData}
                >
                  Load More
                </button>
              )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/IndianDiaspora/Moderation.jsx